import DriverSummaryCard from "./DriverSummaryCard.jsx";

function ManualReviewStep({ driverProfile, onBack, onReset }) {
  return (
    <div className="landstar-step-content">
      <DriverSummaryCard driverProfile={driverProfile} />

      <div className="landstar-manual-card">
        <p className="landstar-kicker">Manual Handling</p>
        <h3>Self-service redemption is not available for this milestone</h3>
        <p>{driverProfile.manualMessage}</p>
        <p className="landstar-helper-text">
          This gives us an MVP-safe branch for the documented exception-year cases without pretending the flow is fully automated.
        </p>
      </div>

      <div className="landstar-inline-actions">
        <button type="button" className="landstar-secondary-button" onClick={onBack}>
          Back
        </button>
        <button type="button" className="landstar-primary-button" onClick={onReset}>
          Start Over
        </button>
      </div>
    </div>
  );
}

export default ManualReviewStep;
